import api from './authService';

export const organizationService = {
  async getOrganizations(params = {}) {
    try {
      const queryString = new URLSearchParams(params).toString();
      const response = await api.get(`/organizations?${queryString}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to fetch organizations' };
    }
  },

  async getOrganization(id) {
    try {
      const response = await api.get(`/organizations/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to fetch organization' };
    }
  },

  async createOrganization(data) {
    try {
      const response = await api.post('/organizations', data);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to create organization' };
    }
  },

  async updateOrganization(id, data) {
    try {
      const response = await api.put(`/organizations/${id}`, data);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to update organization' };
    }
  },

  async toggleStatus(id) {
    try {
      const response = await api.patch(`/organizations/${id}/status`);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to toggle organization status' };
    }
  },

  async deleteOrganization(id) {
    try {
      const response = await api.delete(`/organizations/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to delete organization' };
    }
  },

  async updateStats(id, stats) {
    try {
      const response = await api.patch(`/organizations/${id}/stats`, stats);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to update organization stats' };
    }
  },

  async updatePlan(id, plan, planId) {
    try {
      const response = await api.patch(`/organizations/${id}/plan`, { plan, planId });
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to update subscription plan' };
    }
  },

  async getTenantAdminStats(organizationId, adminId) {
    try {
      const response = await api.get(`/organizations/${organizationId}/tenant-admin/${adminId}/stats`);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to fetch tenant admin statistics' };
    }
  }
};
